import { pick } from 'ramda';
import { createSlice } from '@reduxjs/toolkit';
import { pickExisting } from '@twnel/web-components';
import { USER } from '../namespace';

const userSlice = createSlice({
  name: USER,
  initialState: {},
  reducers: {
    update: {
      reducer: (state, { payload = {} }) => {
        Object.assign(state, pickExisting(
          ['userId', 'auth', 'aws', 'photo', 'name', 'firstTime', 'installed', 'defaultCompany'],
          payload,
        ));
      },
      prepare: ({
        userId, auth, aws, photo, name, firstTime, installed, defaultCompany,
      } = {}) => ({
        payload: {
          userId, auth, aws, photo, name, firstTime, installed, defaultCompany,
        },
      }),
    },
    connection: {
      reducer: (state, { payload = {} }) => {
        Object.assign(state, pickExisting(['connected', 'online'], payload));
      },
      prepare: ({ connected, online }) => ({ payload: { connected, online } }),
    },
    logout: (state) => pick(['userId', 'photo', 'name', 'defaultCompany'], state),
  },
});

export const {
  update: updateUser,
  connection: updateConnectionState,
  logout: logoutUser,
} = userSlice.actions;

export default { [USER]: userSlice.reducer };
